@if (status()) {
    <div
        class="{{ statusColorMap[status()] }} {{
            sizeMap[size()]
        }} font-semibold flex items-center justify-center gap-2 whitespace-nowrap"
    >
        @if (isOnHold()) {
            <sh-icon icon="pause-circle" size="s"></sh-icon>
        }
        {{ 'tasks.' + status() | translate }}
    </div>
}
